import { render } from "./WalLet.vue?vue&type=template&id=781a5d50"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/WalLet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "781a5d50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('781a5d50', __exports__)) {
    api.reload('781a5d50', __exports__)
  }
  
  module.hot.accept("./WalLet.vue?vue&type=template&id=781a5d50", () => {
    api.rerender('781a5d50', render)
  })

}


export default __exports__